import { getSupervisorReceiptConfigurationStore } from "../../../../stores/supervisor-store/supervisor-receipt-configuration-store";
import Et3Button from "../../../../core/et3-button";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";

const SaveReceiptsConfigurationDashboard = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="flex-start"
      alignItems="center"
      withShadow={false}
      width={1500}
      height={60}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3Button
        onClick={async () =>
          await getSupervisorReceiptConfigurationStore().insertReceiptsConfigurationData()
        }
        isEnabled={getSupervisorReceiptConfigurationStore().isSaveButtonEnabled.get()}
        size="LARGE"
        text="SAVE"
        type="GET"
      />
    </ET3Div>
  );
});
export default SaveReceiptsConfigurationDashboard;
